<template>
  <div>
    <vm-table
        ref="vmTable"
        height="62vh"
        :filter.sync="filter"
        module="basic"
        url="purchaseReceiveDetails"
        @select="selectHandler"
        @select-all="selectHandler">
      <div slot="toolbar">
        <el-button v-if="printAuth" :loading="printLoading" type="primary" @click="checkNote">打印送货单</el-button>
        <el-button v-if="aogAuth" :loading="scanLoading" type="success" @click="aOGScan">到货扫描</el-button>
        <el-button v-if="inStockAuth" :loading="inStoreScanLoading" type="success" @click="inStoreScan">入库扫描</el-button>
        <el-button
            v-if="delAuth"
            :loading="confirmLoading"
            :disabled="selection.length === 0"
            type="primary"
            @click="straightConfirm">
          直发确认
        </el-button>
        <el-button v-if="delAuth" type="primary" :loading="exportLoading" @click="exportExcel()">明细导出</el-button>
        <el-button
            v-if="delAuth"
            type="primary"
            :loading="exportLoading"
            :disabled="selection.length === 0"
            @click="updateNo">
          更新送货单号
        </el-button>
      </div>
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="采购订单：">
            <el-input 
                v-model.trim="filter.purchaseOrderNo" 
                type="textarea" 
                autosize 
                placeholder="请输入采购单号" 
                clearable/>
          </vm-search>
          <vm-search label="送货单号：">
            <el-input 
                v-model.trim="filter.no" 
                type="textarea" 
                autosize 
                placeholder="请输入送货单号" 
                clearable/>
          </vm-search>
          <vm-search label="物料编号：">
            <el-input v-model.trim="filter.materialNo" placeholder="请输入物料编号" clearable/>
          </vm-search>
          <vm-search label="送货单状态：">
            <el-select v-model.trim="filter.status" placeholder="请选择状态">
              <el-option label="全部" :value="-1"/>
              <el-option label="待提交" :value="0"/>
              <el-option label="已提交" :value="10"/>
              <el-option label="已到货" :value="11"/>
              <el-option label="已质检" :value="30"/>
              <el-option label="已入库" :value="50"/>
              <el-option label="退回" :value="98"/>
            </el-select>
          </vm-search>
          <vm-search label="直发标识:">
            <el-select v-model.trim="filter.straightMark" placeholder="请选择">
              <el-option label="全部" value="-1"/>
              <el-option label="按单直发工地" value="按单直发工地"/>
              <el-option label="备库直发工地" value="备库直发工地"/>
              <el-option label="发新时达" value="发新时达"/>
            </el-select>
          </vm-search>
        </div>
        <div>
          <vm-search label="直发完结:">
            <el-select v-model.trim="filter.straightFlag" placeholder="请选择">
              <el-option label="全部" :value="-1"/>
              <el-option label="已完结" :value="1"/>
              <el-option label="未完结" :value="0"/>
            </el-select>
          </vm-search>
          <vm-search label="供应商编号：">
            <el-input v-model.trim="filter.gysCode" placeholder="请输入编号" clearable/>
          </vm-search>
          <vm-search label="供应商名称：">
            <el-input v-model.trim="filter.supplierName" placeholder="请输入名称" clearable/>
          </vm-search>
          <vm-search label="采购组：">
            <el-input v-model.trim="filter.buyUserName" placeholder="请输入采购组" clearable/>
          </vm-search>
          <vm-search label="库位：">
            <el-input v-model.trim="filter.location" placeholder="请输入库位" clearable/>
          </vm-search>
        </div>
        <div class="vm-search">
          <vm-search label="创建日期：">
            <div class="block">
              <el-date-picker
                  v-model="filter.createDateBegin"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.createDateEnd"
                  style="width:163px"
                  value-format="yyyy-MM-dd"
                  placeholder="请选择"
                  type="date"/>
            </div>
          </vm-search>
          <vm-search label="到货时间：">
            <div class="block">
              <el-date-picker
                  v-model="filter.arrivedTimeBegin"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.arrivedTimeEnd"
                  style="width:163px"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"/>
            </div>
          </vm-search>
          <vm-search label="入库时间：">
            <div class="block">
              <el-date-picker
                  v-model="filter.inStockTimeBegin"
                  style="width:150px"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"/>
            </div>
          </vm-search>
          <vm-search label="至">
            <div class="block">
              <el-date-picker
                  v-model="filter.inStockTimeEnd"
                  style="width:163px"
                  value-format="yyyy-MM-dd"
                  type="date"
                  placeholder="请选择"/>
            </div>
          </vm-search>
        </div>
      </template>
      <el-table-column type="selection" align="center" width="50"/>
      <el-table-column prop="purchaseReceiveNO" align="center" label="送货单号/行号" width="160">
        <template slot-scope="scope">
          <span style="color: #2d8cf0;cursor: pointer;" @click="$refs.deliveryDetail.open(scope.row.mastPKID)">{{scope.row.purchaseReceiveNO + "/" + scope.row.rowIndex}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="statusName" align="center" label="状态" width="70"/>
      <el-table-column prop="sapmaterialNO" align="center" label="物料编号" width="100"/>
      <el-table-column
          prop="sapmaterialName"
          align="left"
          label="物料描述"
          min-width="320"
          show-overflow-tooltip/>
      <el-table-column
          prop="supplierName"
          align="center"
          label="供应商"
          min-width="180"
          show-overflow-tooltip/>
      <el-table-column prop="evaluate" align="center" label="采购订单/行号" width="140">
        <template slot-scope="scope">
          <span>{{scope.row.evaluate + "/" + scope.row.podetailRowNO}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="buyUserName" align="center" label="采购组" width="100"/>
      <el-table-column prop="responseDeliveryTime" align="center" label="交货/要货日期" width="100">
        <template slot-scope="scope">
          <span>{{scope.row.responseDeliveryTime ? scope.row.responseDeliveryTime.substring(0, 10) : ""}}</span>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" align="center" label="送货数" width="70"/>
      <el-table-column prop="receivedQuantity" align="center" label="到货数" width="70"/>
      <el-table-column prop="qualifiedQuantity" align="center" label="质检数" width="70"/>
      <el-table-column prop="instockQuantity" align="center" label="入库数" width="70"/>
      <el-table-column prop="location" align="center" label="库位" width="70"/>
      <el-table-column prop="straightMark" align="center" label="直发标识" width="100"/>
      <el-table-column prop="createdTime" align="center" label="创建时间" width="140"/>
      <el-table-column prop="arrivedTime" align="center" label="到货时间" width="140"/>
      <el-table-column prop="inStockTime" align="center" label="入库时间" width="140"/>
      <el-table-column prop="sapVoucher" align="center" label="SAP物料凭证" width="100"/>
      <el-table-column prop="straightFlag" align="center" label="直发完结" width="100">
        <template slot-scope="scope">
          <span v-if="scope.row.straightFlag">是</span>
          <span v-else>否</span>
        </template>
      </el-table-column>
      <el-table-column
          v-if="editAuth || delAuth || submitAuth || rollBackAuth || stockReturnAuth"
          label="操作"
          fixed="right"
          align="center"
          width="240">
        <template slot-scope="scope">
          <span v-if="editAuth" style="margin-left: 2px">
            <el-button :disabled="scope.row.status !== 0" type="primary" @click="$refs.createDeliveryBillDialog.open(scope.row.mastPKID)">编辑</el-button>
          </span>
          <span v-if="submitAuth" style="margin-left: 2px">
            <el-button type="success" :disabled="scope.row.status !== 0" @click="submit(scope.row.mastPKID)">提交</el-button>
          </span>
          <span v-if="delAuth" style="margin-left: 2px">
            <el-button type="danger" :disabled="(scope.row.status !== 0 && !managerDelAuth) || scope.row.status===50" @click="deleteOne(scope.row.mastPKID)">删除</el-button>
          </span>
          <span v-if="rollBackAuth" style="margin-left: 2px">
            <el-button type="primary" :disabled="scope.row.status !== 10 && !managerDelAuth" @click="rollBack(scope.row.mastPKID)">退回</el-button>
          </span>
          <span v-if="stockReturnAuth" style="margin-left: 2px">
            <el-button type="primary" :disabled="scope.row.status === 10 || scope.row.status === 0 || scope.row.instockQuantity === 0" @click="stockReturn(scope.row.pkid)">冲销</el-button>
          </span>
        </template>
      </el-table-column>
    </vm-table>
    <create-delivery-bill-dialog ref="createDeliveryBillDialog" @save-success="getList(1)"/>
    <delivery-detail ref="deliveryDetail"/>
    <delivery-in-stock-detail ref="deliveryInStockDetail" @save-success="getList(1)"/>
    <el-dialog
        v-el-drag-dialog
        width="400px"
        :visible.sync="noteDialogVisible"
        :close-on-click-modal="false"
        title="打印参数配置">
      <el-form
          ref="form"
          :model="filter"
          :rules="ruleValidate"
          class="form"
          label-width="120px">
        <el-form-item label="打印备注" prop="notePrint">
          <el-select v-model="filter.notePrint" placeholder="请选择">
            <el-option label="是" :value="true"/>
            <el-option label="否" :value="false"/>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="noteDialogVisible = false">取消</el-button>
        <el-button :loading="printLoading" type="primary" @click="printPurchaseReceive(filter.notePrint)">打印</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";
  import CreateDeliveryBillDialog from "./CreateDeliveryBillDialog.vue";
  import DeliveryDetail from "@/views/purchase/purchaseDelivery/DeliveryDetail";
  import DeliveryInStockDetail from "@/views/purchase/purchaseDelivery/DeliveryInStockDetail";

  export default {
    name: "DeliveryList",
    components: {DeliveryInStockDetail, DeliveryDetail, VmTable, VmSearch, CreateDeliveryBillDialog },
    data() {
      return {
        editAuth: this.$auth(229),
        delAuth: this.$auth(289),
        submitAuth: this.$auth(290),
        printAuth: this.$auth(292),
        aogAuth: this.$auth(293),
        inStockAuth: this.$auth(294),
        rollBackAuth:this.$auth(953),
        stockReturnAuth:this.$auth(377),
        managerDelAuth:this.$auth(389),
        noteDialogVisible:false,
        printLoading: false,
        scanLoading: false,
        inStoreScanLoading: false,
        confirmLoading:false,
        exportLoading: false,
        ids: [],
        purchaseReceiveNos: [],
        selection: [],
        filter: {
          status: -1,
          straightMark:"-1",
          buyUserName:"",
          location:"",
          notePrint:true,
          straightFlag:-1,
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      selectHandler(selection) {
        this.selection = selection;
        this.ids = [];
        this.purchaseReceiveNos = [];
        for (let item of this.selection) {
          this.ids.push(item.mastPKID);
          this.purchaseReceiveNos.push(item.purchaseReceiveNO);
        }
        console.log(this.ids);
      },
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      // 打印发货单
      checkNote() {
        if (this.ids.length === 0) {
          this.$message.error("请至少选择一条需要打印的送货单");
          return;
        }
        this.noteDialogVisible = true;
      },

      printPurchaseReceive(notePrint) {
        console.log(notePrint);
        if (this.selection.find((item) => item.status === 0)) {
          this.$confirm("确认打印吗?打印后的订单无法修改", "提示", { type: "warning" }).then(() => {
            this.printLoading = true;
            this.$http
              .postForFile("basic", "purchaseReceives/printPurchaseReceiveVO/"+notePrint, this.ids)
              .then((res) => {
                console.log(res);
                let blob = new Blob([res.data], {type: "application/pdf"});
                let pdfUrl = window.URL.createObjectURL(blob);
                window.open(pdfUrl);
                this.printLoading = false;
                this.selection = [];
                this.ids = [];
                this.getList();
              }).catch(() => {
                this.$refs.vmTable.clearSelection();
                this.printLoading = false;
              });
          });
        } else {
          this.printLoading = true;
          this.$http
            .postForFile("basic", "purchaseReceives/printPurchaseReceiveVO/"+notePrint, this.ids)
            .then((res) => {
              let blob = new Blob([res.data], {type: "application/pdf"});
              let pdfUrl = window.URL.createObjectURL(blob);
              window.open(pdfUrl);
              this.printLoading = false;
              this.selection =[];
              this.ids = [];
              this.getList();
            }).catch(() => {
              this.$refs.vmTable.clearSelection();
              this.printLoading = false;
            });
        }

      },
      // 到货扫描
      aOGScan() {
        if (this.purchaseReceiveNos.length === 0) {
          this.$message.error("请至少选择一条需要扫描的送货单");
          return;
        }
        for (let item of this.selection) {
          if (item.status!==10) {
            this.$message.error("请选择已提交的送货单");
            return;
          }
        }
        this.scanLoading = true;
        this.$http
          .post("basic", "purchaseReceives/aogScan", this.purchaseReceiveNos)
          .then((res) => {
            console.log(res);
            this.$message.success("扫描成功");
            this.scanLoading = false;
            this.purchaseReceiveNos = [];
            this.getList();
            this.scanLoading = false;
          }).catch((e) => {
            this.$message.error("扫描失败" + e.response.data.message);
            this.purchaseReceiveNos = [];
            this.scanLoading = false;
          });
      },
      inStoreScan() {
        if (!this.purchaseReceiveNos.length) {
          this.$message.error("请选择一条需要扫描的送货单");
          return;
        }
        const WrongStatusList = this.selection.filter(item=> item.status === 50);
        var message = "";
        if(WrongStatusList.length > 0) {
          WrongStatusList.forEach((item)=>{
            message += "采购单号：" + item.evaluate + ",行号：" + item.podetailRowNO + "为已入库状态无法扫描" + "<br/>";
          });
          this.$message({
            message:message,
            type:"error",
            dangerouslyUseHTMLString: true,
          });
          return;
        }
        this.$refs.deliveryInStockDetail.open(this.purchaseReceiveNos[0]);
      },
      rollBack(id) {
        this.$confirm("确定退回吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "purchaseReceives/rejectPurchaseReceiveByPurchaser/" + id).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      stockReturn(id) {
        this.$confirm("确定冲销吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "purchaseReceiveDetails/stockReturn/" + id).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      submit(pkid) {
        this.$confirm("确定提交吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "purchaseReceives/submitPurchaseReceive/" + pkid).then(() => {
            this.$message.success("操作成功");
            this.getList(-1);
          });
        });
      },
      deleteOne(pkid) {
        this.$confirm("确定删除吗?", "提示", { type: "warning" }).then(() => {
          this.$http.get("basic", "purchaseReceives/deletePurchaseReceive/" + pkid).then(() => {
            this.$message.success("删除成功");
            this.getList(-1);
          });
        });
      },

      //直发确认
      straightConfirm() {
        const no=this.purchaseReceiveNos.every((item)=> item===null);
        if (no) {
          this.$confirm("送货单号为null,请更新送货单号", "错误", {
            type: "error",
            showCancelButton: false,
          });
        }else {
          this.confirmLoading = true;
          let idList= [];
          this.selection.forEach(item=>{
            idList.push(item.mastPKID);
          });
          this.$http.post("basic","purchaseReceives/straightConfirm",idList).then(()=>{
            this.$message.success("送货单已入库，已通知采购和销售，对应发货单已过账");
            this.selection =[];
            this.ids = [];
            this.getList(1);
            this.confirmLoading = false;
          }).catch(()=>{
            this.$refs.vmTable.clearSelection();
            this.confirmLoading = false;
            this.getList(1);
          });
        }


      },
      exportExcel() {
        this.exportLoading = true;
        this.$http
          .exportFile("basic", "purchaseReceiveDetails/export", this.filter)
          .then(res => {
            console.log(res);
            let blob = new Blob([res.data]);
            let fileName = decodeURI(res.headers.filename);
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              navigator.msSaveBlob(blob, fileName);
            } else {
              let a = document.createElement("a");
              a.href = URL.createObjectURL(blob);
              a.download = fileName;
              a.style.display = "none";
              document.body.appendChild(a);
              a.click();
              URL.revokeObjectURL(a.href);
              document.body.removeChild(a);
            }
            this.exportLoading = false;
          })
          .catch(() => {
            this.exportLoading = false;
          });
      },

      updateNo() {
        let check=true;
        const id=this.ids.every((item)=>item===this.ids[0]);
        const no=this.purchaseReceiveNos.every((item)=> item===null);

        if (!id) {
          this.$confirm("送货单不一致,请重新选择", "错误", {
            type: "error",
            showCancelButton: false,
          });
          check = false;
        }

        if (!no) {
          this.$confirm("送货单不为null,请重新选择", "错误", {
            type: "error",
            showCancelButton: false,
          });
          check = false;
        }

        if (check) {
          this.$http.get("basic", `purchaseReceives/updateNo/${this.ids[0]}`)
            .then(()=>{
              this.$message.success("更新成功");
              this.getList(1);
            }).catch(()=>{
              this.$message.error("更新失败");
              this.getList(1);
            });
        }
      },
    },
  };
</script>
<style lang="scss" scoped></style>
